<template>
  <div class="contract-data">
    <h3>{{patient.name}}</h3>
    <p>{{date}}</p>
    <p>
      <i class="fab fa-ethereum"></i>
      {{patient.wallet}}
    </p>

    <h5>Razón de la visita</h5>
    <p>{{reason}}</p>

    <div class="property" v-for="field in fields" v-bind:key="field.property">
      <h5>{{field.translation}}</h5>
      <p>{{externalData[field.property]}}</p>
    </div>
    <h3>Archivos ipfs</h3>
    <ul class="ipfs-list">
      <li v-for="file in files" class="ipfps-file" v-bind:key="file[1]">
        <i class="fa fa-file"></i>
        <a :href="`https://ipfs.io/ipfs/${file[1]}`" target="_blank">{{file[0]}}</a>
      </li>
    </ul>
  </div>
</template>


<script>
import VisitsManager from "../managers/visitsManager";
// import MedicsManager from '../managers/medicsManager'
// import PatientsManager from "../managers/patientsManager";
import fileFields from "../config/contractFields.json";
import IpfsClient from "../managers/IpfsManager";
import gun from "../managers/gun";
import Gun from "gun";
const sea = Gun.SEA;
let properties = {};
for (var prop of fileFields) {
  properties[prop.name] = "";
}
export default {
  props: [
    "isMedic"
  ],
  data() {
    return {
      patient: { name: "" },
      files: [],
      reason: "",
      externalData: properties,
      date: null,
      fields: fileFields,
      ipfs: process.env.VUE_APP_IPFS
    };
  },
  async created() {
    gun
      .get("hospitalizations")
      .get(this.$route.params.id)
      .once(async data => {
        let patientUser = await gun.user(this.isMedic ? data.patient : data.medic);
        let secret = await sea.secret(patientUser.epub, gun.user()._.sea);
        let decrypted = await sea.decrypt(await gun.get("hospitalizations").get(this.$route.params.id).get("data"), secret);
        console.log(decrypted)
        var contract = await VisitsManager.GetVisit(decrypted.externalID);
        var msg = await contract.methods.getOwner();
        msg.call(console.log);
        msg = await contract.methods.getPatient();
        console.log(msg);
        msg.call((i, val) => {
          console.log("medic :", val);
          gun
            .user(data.patient)
            .get("profile")
            .once(profile => (this.patient = profile));
          // PatientsManager.GetPatient(val).then(patient => (this.patient = patient));
        });
        msg = await contract.methods.files();
        console.log("files")
        msg.call(async (i, val) => {
          // for (let file of val) {
          //   console.log(file);
          //   console.log(file);
          // }
          this.files = val;
        });

        msg = await contract.methods.externalProperties();
        msg.call(async (i, val) => {
          console.log("external properties", val);
          for (let file of val) {
            var data = await IpfsClient.ReadFile(file.fileHash);
            let fieldData = Buffer.from(data.content).toString();
            console.log(fieldData);
            console.log(secret);

            this.externalData[file.name] = await sea.decrypt(
              String(fieldData),
              secret
            );
            this.$nextTick(() => this.$forceUpdate());
          }
        });
        // IpfsClient.ReadFile()
        msg = await contract.methods.getReason();
        msg.call((i, val) => {
          this.reason = val;
        });
        msg = await contract.methods.getDate();
        msg.call((i, val) => {
          let date = new Date();
          date.setTime(val);
          this.date = date.toLocaleString();
        });
      });
  }
};
</script>


<style lang="scss" scoped>
.contract-data {
  background-color: white;
  margin-top: 5em;
  padding: 2em;
  .ipfs-list {
    list-style: none;
    .fa {
      margin-right: 1em;
    }
  }
}
</style>